export { default as DeleteInvestmentDialog } from './DeleteInvestmentDialog';
